import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import {
  useFindServiceProviderDetailByIdMutation,
  useFindServiceProviderDetailByUserIdMutation,
  useGetAllServiceProviderDetailMutation,
  useSaveServiceProviderDetailMutation,
  useUpdateServiceProviderDetailMutation,
} from '../store/api/serviceProviderApi';

type Props = {};

const TestingComponent = (props: Props) => {
  const [getAllServiceProviderDetail, response] = useGetAllServiceProviderDetailMutation();
  const [findServiceProviderById, responseObject] = useFindServiceProviderDetailByIdMutation();
  const [findServiceProviderByUserId, responseBody] = useFindServiceProviderDetailByUserIdMutation();
  const [saveServiceProviderDetail, responseK] = useSaveServiceProviderDetailMutation();
  const [updateServiceProviderDetail, responseKD] = useUpdateServiceProviderDetailMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  useEffect(() => {
    if (response.isSuccess) {
      toast.success('Get All Service Provider Detail Successful');
    }
  }, [response.isSuccess]);
  useEffect(() => {
    if (responseObject.isSuccess) {
      toast.success('Find Service Provider Detail Successful');
    }
  }, [responseObject.isSuccess]);
  useEffect(() => {
    if (responseBody.isSuccess) {
      toast.success('FindServiceProviderByUserId Success');
    }
  }, [responseBody.isSuccess]);
  useEffect(() => {
    if (responseK.isSuccess) {
      toast.success('saveServiceProviderDetail Success');
    }
  });
  useEffect(() => {
    if (responseKD.isSuccess) {
      toast.success('updateServiceProviderDetail Success');
    }
  });
  return (
    <div style={{ padding: '25px' }}>
      <Button
        onClick={() => {
          getAllServiceProviderDetail({ token: token.token, page: 0, offset: 10 });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - getAllServiceProviderDetail
      </Button>
      <div></div>
      <Button
        onClick={() => {
          findServiceProviderById({ token: token.token, id: 8 });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - findServiceProviderById
      </Button>
      <div>
        <Button
          onClick={() => {
            findServiceProviderByUserId({ token: token.token, userId: 300 });
          }}
          variant="outlined"
          style={{ marginBottom: '10px' }}
        >
          Test Api - findServiceProviderDetailByUserId
        </Button>
      </div>
      <div>
        <Button
          onClick={() => {
            saveServiceProviderDetail({
              token: token.token,
              reqData: {
                contactNumber: '9892422130',
                emailId: 'vendor4@spotfinder.io',
                name: 'Captain America',
                password: 'SpotFinder',
                status: true,
              },
            });
          }}
          variant="outlined"
          style={{ marginBottom: '10px' }}
        >
          Test Api - saveServiceProviderDetail
        </Button>
      </div>
      <div>
        <Button
          onClick={() => {
            updateServiceProviderDetail({
              token: token.token,
              reqData: {
                contactNumber: '8790654321',
                emailId: 'vendor2@spotfinder.io',
                id: 9,
                name: 'Mr Bean',
                password: 'SpotFinder',
                userId: 303,
              },
            });
          }}
          variant="outlined"
          style={{ marginBottom: '10px' }}
        >
          Test Api - updateServiceProviderDetail
        </Button>
      </div>
    </div>
  );
};

export default TestingComponent;
